import React from 'react';
import { useActions } from '@src/containers/Session/hooks';
import { MODAL_IDS } from '@src/containers/Session/constants';
import { ANALYTICS_GOAL, useReachGoal } from '@src/libs/hooks/useReachGoal';

import Advert from '..';

const AdvertCDefault = () => {
	const { toggleModal } = useActions();
	const { reachGoal } = useReachGoal();

	const handleClick = React.useCallback(() => {
		reachGoal(ANALYTICS_GOAL.click_offer_banner);
		toggleModal({ modalId: MODAL_IDS.CHOICE, isOpen: true });
	}, [reachGoal, toggleModal]);

	return (
		<Advert
			linkLabel={t('Отправить заявку')}
			pre={t('Поможем найти')}
			title={t('подходящую площадку')}
			text={t(
				'Отправьте нашей команде заявку на подбор площадки. Мы пришлем вам список лучших вариантов.',
			)}
			onClick={handleClick}
		/>
	);
};

export default AdvertCDefault;
